import React from "react";
import Image from "next/image";
import { useAuth } from "../auth/useAuth";
import { useColorScheme } from "../settings/ColorScheme";
import { CtaBanner } from "../share/CtaBanner";

const CTA_BANNER_HEIGHT = 100;

/**
 * Header, footer, and background for public pages.
 * Uses the favorite color scheme of the user, if they have an account.
 */
export const PublicPage = ({ children }: { children?: React.ReactNode }) => {
  const colorScheme = useColorScheme();
  const { isAuthenticated } = useAuth();
  return (
    <div
      style={{
        marginTop: 24,
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        overflow: "auto",
        height: "100vh",
        display: "flex",
      }}
    >
      <Image
        alt="logo"
        src={colorScheme !== "dark" ? "/logo-light.svg" : "/logo-dark.svg"}
        width="120px"
        height="24px"
      ></Image>
      <div
        style={{
          marginTop: "48px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 720,
        }}
      >
        {children}
        <div style={{ height: CTA_BANNER_HEIGHT + 56 }}></div>
        {!isAuthenticated && (
          <CtaBanner
            height={CTA_BANNER_HEIGHT}
            text="Ideaflow: zero-friction, AI notebook"
            ctaText="Request access"
            onClick={() => window.open("https://ideaflow.io", "_blank")}
          />
        )}
        {isAuthenticated && (
          <CtaBanner
            height={CTA_BANNER_HEIGHT}
            text=""
            ctaText="Go to my Ideaflow"
            onClick={() => (window.location.href = "/")}
          />
        )}
      </div>
    </div>
  );
};
